import { config } from 'config';

interface IndustryArgs {
  industryCode: string;
}

interface OccupationArgs extends IndustryArgs {
  occupationCategory: string;
}

interface QuoteArgs {
  quoteNumber: string;
}

interface PolicyArgs {
  policyNumber: string;
}

interface GuidArgs {
  guid: string;
}

interface AbnArgs {
  abn: string;
}

// Define a generic function to handle different argument types.
function withArgs<T>(fn: (args: T) => string) {
  return (args?: T | Record<string, unknown>) => fn(args as T);
}

interface ApiMappings {
  [key: string]: string | ((args?: Record<string, unknown>) => string);
}

export const apiMappings: ApiMappings = {
  'sitecoreApi/executeQuery:sitecoreConfig': config.sitecoreConfigurationApi,
  'refDataApi/executeQuery:getIndustries': `${config.msCommercialInsApi}/industries`,
  'refDataApi/executeQuery:getOccupationCategories': withArgs(
    (args: IndustryArgs) =>
      `${config.msCommercialInsApi}/ref-data/industries/${args.industryCode}/occupation-categories`
  ),
  'refDataApi/executeQuery:getOccupations': withArgs(
    (args: OccupationArgs) =>
      `${config.msCommercialInsApi}/ref-data/industries/${args.industryCode}/occupation-categories/${args.occupationCategory}/occupations`
  ),
  'refDataApi/executeQuery:getDyanmicCoverQuestions': `${config.msCommercialInsApi}/ref-data/cover-options`,
  'refDataApi/executeQuery:getOccupationsList': `${config.msCommercialInsApi}/ref-data/occupations`,
  'refDataApi/executeQuery:getDynamicCovers': `${config.msCommercialInsApi}/ref-data/covers`,
  'quotesApi/executeQuery:getQuote': withArgs(
    (args: QuoteArgs) => `${config.msCommercialInsApi}/quotes/${args.quoteNumber}`
  ),
  'quotesApi/executeQuery:saveQuote': `${config.msCommercialInsApi}/quotes/`,
  'quotesApi/executeQuery:updateQuote': `${config.msCommercialInsApi}/quotes/`,
  'quotesApi/executeQuery:bind': withArgs(
    (args: QuoteArgs) => `${config.msCommercialInsApi}/quotes/${args.quoteNumber}/bind`
  ),
  'premiumsApi/executeQuery:quotePremiums': `${config.msCommercialInsApi}/premiums`,
  'policyApi/executeQuery:getPolicy': withArgs(
    (args: PolicyArgs) => `${config.msCommercialInsApi}/policies/${args.policyNumber}`
  ),
  'pciPalApi/executeQuery:getPaymentToken': `${config.msCommercialInsApi}/payment-token`,
  'paymentApi/executeQuery:generateCSKey': `${config.msCommercialInsApi}/payments/cybersource/flex/transactionss`,
  'paymentApi/executeQuery:validateToken': withArgs(
    (args: GuidArgs) =>
      `${config.msCommercialInsApi}/payments/cybersource/flex/transactions/${args.guid}/validate`
  ),
  'historyQuestionApi/executeQuery:getHistoryQuestions': `${config.msCommercialInsApi}/ref-data/history-questions`,
  'addressApi/executeQuery:getAddresses': `${config.msCommercialInsApi}/address`,
  'addressApi/executeQuery:getAddress': `${config.msCommercialInsApi}/address`,
  'addressApi/executeQuery:getFullAddress': `${config.msCommercialInsApi}/address`,
  'addressApi/executeQuery:manualAddressValidation': `${config.msCommercialInsApi}/address/validate`,
  'addressApi/executeQuery:perilLookup': `${config.msCommercialInsApi}/address/peril/search`,
  'abnApi/executeQuery:abnLookup': withArgs(
    (args: AbnArgs) => `${config.msCommercialInsApi}/ref-data/abn-lookup/${args.abn}`
  ),
};
